import { StyleSheet, Text, type TextProps } from "react-native";

import { BrandColors } from "@/constants/theme";
import { useThemeColor } from "@/hooks/use-theme-color";

export type ThemedTextProps = TextProps & {
  lightColor?: string;
  darkColor?: string;
  type?: "default" | "title" | "defaultSemiBold" | "subtitle" | "link" | "small" | "smallSemiBold" | "extraSmall" | "extraSmallSemiBold";
};

export function ThemedText({
  style,
  lightColor,
  darkColor,
  type = "default",
  ...rest
}: ThemedTextProps) {
  const color = useThemeColor({ light: lightColor, dark: darkColor }, "text");

  return (
    <Text
      style={[
        { color },
        type === "default" ? styles.default : undefined,
        type === "title" ? styles.title : undefined,
        type === "defaultSemiBold" ? styles.defaultSemiBold : undefined,
        type === "subtitle" ? styles.subtitle : undefined,
        type === "link" ? styles.link : undefined,
        type === "small" ? styles.small : undefined,
        type === "smallSemiBold" ? styles.smallSemiBold : undefined,
        type === "extraSmall" ? styles.extraSmall : undefined,
        type === "extraSmallSemiBold" ? styles.extraSmallSemiBold : undefined,
        style,
      ]}
      {...rest}
    />
  );
}

const styles = StyleSheet.create({
  default: {
    fontSize: 16,
    fontFamily: "PlusJakartaSans",
    lineHeight: 24,
  },
  defaultSemiBold: {
    fontSize: 16,
    fontFamily: "PlusJakartaSansBold",
    lineHeight: 24,
  },
  title: {
    fontSize: 32,
    fontFamily: "PlusJakartaSansBold",
    lineHeight: 40,
  },
  subtitle: {
    fontSize: 20,
    fontFamily: "PlusJakartaSansBold",
    lineHeight: 24,
  },
  link: {
    fontSize: 16,
    color: BrandColors.primary,
    fontFamily: "PlusJakartaSans",
    lineHeight: 20,
  },
  small: {
    fontSize: 14,
    fontFamily: "PlusJakartaSans",
    lineHeight: 24,
  },
  smallSemiBold: {
    fontSize: 14,
    fontFamily: "PlusJakartaSansBold",
    lineHeight: 24,
  },
  extraSmall: {
    fontSize: 12,
    fontFamily: "PlusJakartaSans",
    lineHeight: 16,
  },
  extraSmallSemiBold: {
    fontSize: 12,
    fontFamily: "PlusJakartaSansBold",
    lineHeight: 16,
  },
});
